module.exports = __webpack_public_path__ + "static/MOiP-Mobile-48cd05091879bccfd1c8a2223487d5a0.gif";